import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";
import { NestingRunView } from "shared";

export const fetchLayoutNesting = async (layoutId: string): Promise<NestingRunView | null> => {
  const response = await api.nesting.getLayoutNesting.query({ params: { id: layoutId } });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to fetch layout nesting", response.status, response.body);
};
